import { environment } from './environments/environment';

export const API_VERSIONs = {
  VERSION_1_0_0: '1.0.0',
  VERSION_2_0_0: '2.0.0',
};

export function buildEndpoint(path: string): string {
  return `${environment.domain.main}/${path}`;
}

export const API_ENDPOINTS = {
  auth: `${environment.domain.apiAuth}`, // <<-- API AUTH
  //#region Project Admin quan ly permission
  permission_v2_file_v2: `${environment.domain.apiAuth}/permission-v2/file-v2`,
  /**
   * Permission v2 admin api
   */
  permission_v2_confApp: `${environment.domain.apiAuth}/conf-app`,
  permission_v2_confApi: `${environment.domain.apiAuth}/conf-api`,
  permission_v2_confMenu: `${environment.domain.apiAuth}/conf-menu`,
  permission_v2_confRole: `${environment.domain.apiAuth}/conf-role`,
  permission_v2_confUserManage: `${environment.domain.apiAuth}/conf-user-manage`,
  //#endregion

  reset_password_email: `${environment.domain.apiSupportEmail}/emailhutech/email-hutech-user`,

  /* PLUGIN */
  'permission_v2_plugins-open_weather_map': `${environment.domain.apiAuth}/plugins/openweathermap`,
  'permission_v2_plugins-unsplash': `${environment.domain.apiAuth}/plugins/unsplash`,
};
